import { pushEvent, ANALYTICS_EVENTS } from '../../utils/analytics';

export const buildLoginRedirectPath = (fullPath) => {
  return `/sales?showLogin=1&successUrl=${encodeURIComponent(window.location.origin + fullPath)}`;
};

export const getCloneAgentTargetId = (cloneResult) =>
  cloneResult?.conversationId || cloneResult?.aiStrategyId;

export async function cloneSharedStrategy({
  strategy,
  aiStrategyId,
  shareToken,
  getApiToken,
}) {
  let token;
  try {
    token = await getApiToken();
  } catch {
    token = null;
  }

  if (!token) {
    return { loginRequired: true, cloneResult: null };
  }

  if (!strategy?.id) {
    throw new Error('Strategy ID is required to clone strategy.');
  }

  const response = await fetch(`${process.env.REACT_APP_API_URL}/ai-bot-builder/clone-strategy`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      strategyId: strategy.id,
      aiStrategyId,
      ...(shareToken ? { shareToken } : {}),
    }),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || 'Failed to clone strategy. Please try again.');
  }

  const cloneResult = await response.json();
  pushEvent({
    event: ANALYTICS_EVENTS.STRATEGY_CLONED,
    originalStrategyId: strategy.id,
    originalAiStrategyId: aiStrategyId,
    clonedStrategyId: cloneResult.strategyId,
    clonedAiStrategyId: cloneResult.aiStrategyId,
    strategyName: strategy.name,
  });

  return { loginRequired: false, cloneResult };
}
